export default __webpack_public_path__ + "static/media/Prospects.14fe7549.svg";